<script>

    import { mode, provetta, location, email, timestamp, height, note } from '../store';
    import { Button, Icon, ListItem, Dialog, Textarea } from 'svelte-materialify';
    import { mdiLink } from '@mdi/js';

    export let _window;
    export let value;

    let _mode, _provetta, _location, _email, _timestamp, _height, _note;

    let _noteContent = "";
    let isNoteDialogVisible = false;

    mode.subscribe(val => _mode = val);
    provetta.subscribe(val => _provetta = val);
    location.subscribe(val => _location = val);
    email.subscribe(val => _email = val);
    timestamp.subscribe(val => _timestamp = val);
    height.subscribe(val => _height = val);
    note.subscribe(val => _note = val);

</script>

<main>

    <div class="container-info pa-3">

        <div class="box white rounded elevation-1 pa-3 black-text">

            <h5 class="text-h5 mt-4 mb-6">
                Riepilogo
            </h5>

            {#if _mode === "start"}

                <ListItem class="pl-0 grey-text text-darken-3">
                    Email
                </ListItem>

                <h6 class="text-h6 mb-6 green-text cut-text">
                    {_email ? _email : "..."}
                </h6>

            {/if}

            <ListItem class="pl-0 grey-text text-darken-3">
                Provetta
            </ListItem>

            <h6 class="text-h6 mb-6 green-text cut-text">
                {_provetta ? _provetta : "..."}
            </h6>

            {#if _mode === "start"}
            
                <ListItem class="pl-0 grey-text text-darken-3">
                    Coordinate
                    <span slot="append">
                        <Button disabled={!_location || typeof(_location) !== "object"} icon depressed on:click={() => {
                            window.open("https://www.google.it/maps/place/" + _location.lat + ", " + _location.lng);
                        }}>
                            <Icon path={mdiLink} />
                        </Button>
                    </span>
                </ListItem>

                <h6 class="text-h6 mb-6 green-text cut-text">
                    {_location && typeof(_location) === "object" ? _location.lat + ", " + _location.lng : "..."}
                </h6>


                <ListItem class="pl-0 grey-text text-darken-3">
                    Altezza
                </ListItem>

                <h6 class="text-h6 mb-6 green-text cut-text">
                    {_height ? _height : "NaN"} mt
                </h6>

            {/if}

            <ListItem class="pl-0 grey-text text-darken-3">
                Data
            </ListItem>

            <h6 class="text-h6 mb-6 green-text">
                {_timestamp ? _timestamp.toLocaleString() : "..."}
            </h6>

            {#if _mode === "start"}
            
                <Button block text class="green-text" on:click={() => isNoteDialogVisible = true}>
                    {_note ? "modifica" : "aggiungi"} commento
                </Button>

            {/if}

            <Button disabled={!_provetta} depressed block class="green white-text mt-4" on:click={_window.next}>
                {_mode === "start" ? "Apri" : "Chiudi"} provetta
            </Button>
            
            <Button depressed outlined block class="red red-text" on:click={() => value = 0}>
                Annulla
            </Button>

        </div>

    </div>

    <Dialog active={isNoteDialogVisible} class="pa-3">
        
        <Textarea color="green" counter={100} filled bind:value={_noteContent}>
            Commento
        </Textarea>

        <Button disabled={_noteContent === "" && !_note} block depressed class="green white-text mt-3" on:click={() => {
            note.set(_noteContent);
            isNoteDialogVisible = false;
        }}>
            {_note ? "Modifica" : "Salva"}
        </Button>

        <Button block depressed outlined class="red-text" on:click={() => {
            isNoteDialogVisible = false;
        }}>
            Chiudi
        </Button>

    </Dialog>

</main>

<style>

    main {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        display: flex;
        flex-direction: column;
    }

    .container-info {
        position: absolute;
        width: 100%;
        height: 100%;
        display: grid;
        place-items: center;
    }

    .box {
        width: 100%;
        height: auto;
        max-height: 95%;
        overflow-y: auto;
    }

    .cut-text { 
        text-overflow: ellipsis;
        overflow: hidden; 
        white-space: nowrap;
    }
    
</style>